import * as React from 'react';
import { ReactSVG } from 'react-svg';

const CustomBtn = ({ label, handleClick, customClass, iconClass, type, disabled, iconSvg }) => {
  const cssClass = `btn ${customClass}`;
  const cssImage = `def ${iconClass}`;

  return (
    <button
      type={type ? 'submit' : 'button'}
      className={cssClass}
      onClick={(e) => handleClick(e)}
      disabled={disabled}
    >
      {iconClass && <i className={cssImage} />}
      {iconSvg && <ReactSVG src={iconSvg} alt="Pause/Resume" />}
      <span>
        {label}
      </span>
    </button>
  );
};

export default CustomBtn;
